<template>
  <div>
    <v-card
      class="mx-auto my-2"
      max-width="344"
      elevation="6"
      :loading="loading"
    >
      <v-card-title style="font-family: Kelly Slab !important">
        {{ item.credor.startsWith("DIVZERO") ? "DIVZERO" : item.credor }}
      </v-card-title>

      <v-card-text>
        <v-row align="center" class="mx-0">
          <v-rating
            :value="5"
            color="amber"
            dense
            half-increments
            readonly
            size="14"
          ></v-rating>
        </v-row>

        <div class="my-2 subtitle-1">
          {{ item.nome.substr(0, 40).toUpperCase() }} <br />
        </div>

        <div>
          Contrato {{ item.contrato }} <br />
          {{ item.diasatraso }} dias de atraso
        </div>
      </v-card-text>

      <v-divider class="mx-4"></v-divider>

      <v-card-title
        >Valor: R$
        {{ valor_divida | dinheiro }}

        <br />{{ item.credor == "LOJAS NALIN" ? " não atualizado" : "*" }}
      </v-card-title>

      <v-card-actions>
        <v-btn color="primary" @click="pegaDivida(item.contrato, item.credor)">
          Ver Detalhes desta Oferta
        </v-btn>
      </v-card-actions>
      <template slot="progress">
        <v-progress-linear
          color="deep-purple"
          height="10"
          indeterminate
        ></v-progress-linear>
      </template>
    </v-card>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { api } from "@/conf/api";
import { calcDividaUnismg } from "../../conf/utilitario";
import { atualizarLogNegoc } from "@/conf/logNegoc";

export default {
  name: "DividasItem",
  data() {
    return {
      loading: false,
      overlay: false,
      tipo_divida: "",
      valor_divzero: "",
      valor_divida: "999999999.00",
    };
  },
  props: ["item"],
  filters: {
    dinheiro: function(value) {
      return parseFloat(value)
        .toFixed(2)
        .replace(".", ",");
    },
  },
  beforeMount() {
    this.valor_divida = this.item.cpsaldev;

    if (this.item.cpcgc == "50510071000102") {
      console.log("item", this.item);
      console.log("divzero", this.$store.state.dividas_divzero);
      const contrato = this.item.contrato;
      const divida = this.$store.state.dividas_divzero.find(
        (item) => item.DebtNumber == contrato,
      );

      if (divida) {
        this.valor_divida = divida.DebtTotalBalance;
      }
    }
  },

  async mounted() {
    //  let valorD;
    // if (this.item.cpcgc == "50510071000102") {
    //   console.log("item", this.item);
    //   console.log("divzero", this.$store.state.dividas_divzero);
    //   //   console.log("entrou divzero1111");
    //   //   console.log("valorD1", valorD);
    //   //   let respA = this.$store.state.dividas_divzero;
    //   //   valorD = respA.filter(function(item) {
    //   //     return item.DebtNumber == this.item.contrato;
    //   //   });
    //   //   console.log("valorD2", valorD);
    // }

    //   let logNegoc = {
    //     credor: this.item.credor2,
    //     cgc: this.item.cpcgc,
    //     cpf: this.item.cpcpfcgc,
    //     contrato: this.item.contrato,
    //     log_status: `cpf ${this.item.cpcpfcgc} saiu da página de dívidas`,
    //     negoc: "",
    //     parcelas_qtde: "",
    //     entrada: "",
    //     parcela: "",
    //   };
    //   await atualizarLogNegoc(logNegoc);
    //   return this.$router.push({ name: "ContatoPage" });
    // }
    // let respA = this.$store.state.dividas_divzero;
    // console.log("respAAA", respA);
    //atualiza divzero
    /*  divzero retirada acesso a api
    if (this.item.cpcgc == "50510071000102") {
      console.log("entrou divzero");
      try {
        this.overlay = true;
        //let cpf = this.item.cpcpfcgc.trim();
        let contrato = this.item.contrato.trim();
        // let cgc = this.item.cpcgc.trim();
        // let remessa = this.item.cpdatrem;
        // let codacordo = this.item.cpcodacordo;
        this.item.credor = this.item.credor2.trim();
        let respA = this.$store.state.dividas_divzero;
        //console.log("respA", respA);
        let dividaAgora = respA.filter(function(divida) {
          return divida.DebtNumber == contrato;
        });

        this.item.cpsaldev = dividaAgora[0].DebtTotalBalance;
        this.tipo_divida = dividaAgora[0].ProductType;

        // console.log("dividaagora", JSON.stringify(dividaAgora[0], null, 2));
        // console.log(
        //   "divzero",
        //   this.item.cpsaldev,
        //   cpf,
        //   cgc,
        //   contrato,
        //   remessa,
        //   codacordo,
        // );

        this.overlay = false;
      } catch (e) {
        console.log("err", e.message);
        this.$router.push({ name: "ErroPage" });
      }
    }
    */
    //atualiza unismg
    if (this.item.cpcgc == "31404878000116") {
      try {
        this.overlay = true;
        let cpf = this.item.cpcpfcgc.trim();
        let contrato = this.item.contrato.trim();
        let cgc = this.item.cpcgc.trim();
        let remessa = this.item.cpdatrem;
        let codacordo = this.item.cpcodacordo;
        // let respA = await api.get(`logs/updatecodacordo/${cpf}`);
        console.log(
          "u",
          this.item.cpsaldev,
          cpf,
          cgc,
          contrato,
          remessa,
          codacordo,
        );

        let resp = await api.post("unismg/dadosparcelacriterio", {
          cpf,
          cgc,
          contrato,
          remessa,
          codacordo,
        });
        //console.log('resp',resp.data)
        let faturas = resp.data.dados.faturas;
        this.$store.dispatch("insereUnismgFaturas", faturas);
        let criterios = resp.data.dados.criterios[0];
        this.$store.dispatch("insereUnismgCriterios", criterios);
        // console.log('crit',this.$store.state.unismg_criterios)
        let var_mora = parseFloat(criterios.perc_mora);
        let multa = parseFloat(criterios.perc_multa);
        let desc_avista = parseFloat(criterios.perc_desconto_avista);
        let desc_encargos = parseFloat(criterios.perc_desc_encargos);
        let desc_parc = parseFloat(criterios.perc_desconto_parc);
        let perc_entrada = parseFloat(criterios.perc_entrada);
        let parc_min = parseFloat(criterios.parcela_minima);

        let qtdeFaturas = faturas.length;

        let totalFaturas = 0,
          moraTotal = 0,
          multaTotal = 0;
        let dataVenc;

        faturas.forEach((e) => {
          totalFaturas = totalFaturas + parseFloat(e.pdvalor);
          let difdatas = calcDividaUnismg(e.pddtvencto.substring(0, 10));
          let ano2023 = e.pddtvencto.substring(0, 4);
          //console.log('ano23',ano2023,e.pddtvencto.substring(0,4))
          dataVenc = difdatas.d2;

          let valor1 = 0;
          let mora_por_fatura = 0;
          let multa_por_fatura = 0;

          //só reajusta se ano da fat maior ou igual a 2023
          if (parseFloat(ano2023) >= 2023) {
            valor1 = parseFloat(e.pdvalor) * difdatas.dias;
            mora_por_fatura = (var_mora / 30 / 100) * valor1;
            multa_por_fatura = (parseFloat(e.pdvalor) * multa) / 100;
          }

          multaTotal = multaTotal + multa_por_fatura;
          moraTotal = moraTotal + mora_por_fatura;
        });

        let divida_atualizada = totalFaturas + moraTotal + multaTotal;

        divida_atualizada = Math.ceil(divida_atualizada * 100) / 100;
        console.log("div", divida_atualizada, divida_ori);

        let divida_ori = this.item.cpsaldev;
        this.item.cpsaldev = divida_atualizada; //parseFloat(divida_str2)

        let pri = totalFaturas * (desc_avista / 100);
        let pri2 = moraTotal + multaTotal;
        let pri3 = (moraTotal + multaTotal) * (desc_encargos / 100);

        let _1x = totalFaturas - pri + (pri2 - pri3);

        _1x = Math.ceil(_1x * 100) / 100;
        /* código antigo
        let p1 =
          totalFaturas - totalFaturas * (desc_parc / 100) + (pri2 - pri3);

        let p2 = perc_entrada / 100;

        let entrada = p1 * p2;

        entrada = Math.ceil(entrada * 100) / 100;

        let diferenca = p1 - entrada;
        diferenca = Math.ceil(diferenca * 100) / 100;

        let _3xdemais = diferenca / 2;
        //console.log('demais3',_3xdemais)
        _3xdemais = Math.ceil(_3xdemais * 100) / 100;
        //console.log('3xdemais',_3xdemais)
        let _5xdemais = diferenca / 4;
        //console.log('demais5',_5xdemais)
        _5xdemais = Math.ceil(_5xdemais * 100) / 100;
*/
        //*************************************teste do paulo */
        let p1 =
          totalFaturas - totalFaturas * (desc_parc / 100) + (pri2 - pri3);

        let entrada = 0;
        let _3xdemais = 0;
        let _5xdemais = 0;

        do {
          let p2 = perc_entrada / 100;

          entrada = Math.ceil(p1 * p2 * 100) / 100;

          let diferenca = Math.ceil((p1 - entrada) * 100) / 100;

          _3xdemais = Math.ceil((diferenca / 2) * 100) / 100;
          _5xdemais = Math.ceil((diferenca / 4) * 100) / 100;

          perc_entrada += 1;
        } while (entrada < _3xdemais || entrada < _5xdemais);
        //*************************************teste do paulo */
        let obj = {
          cpf,
          contrato,
          cgc,
          remessa,
          divida_atualizada,
          divida_ori,
          _1x,
          entrada,
          _3xdemais,
          _5xdemais,
          dataVenc,
          qtdeFaturas,
          parc_min,
          codacordo,
        };
        this.$store.dispatch("insereUnismgValores", obj);
        //---------------------------------------------------------

        this.overlay = false;
      } catch (e) {
        console.log("err", e.message);
        this.$router.push({ name: "ErroPage" });
      }
    }
    // atualiza plural
    // if (this.item.cpcgc == "97553801000116") {
    //   this.$router.push({ name: "ErroPage" });
    // }
    //atualiza plural
    //
    if (this.item.cpcgc == "97553801000116") {
      console.log("entrou");
      try {
        this.overlay = true;
        let cpf = this.item.cpcpfcgc.trim();
        let contrato = this.item.contrato.trim();
        let cgc = this.item.cpcgc.trim();
        let remessa = this.item.cpdatrem.substring(0, 10);
        let codacordo = this.item.cpcodacordo;
        console.log(
          "p",
          this.item.cpsaldev,
          cpf,
          cgc,
          contrato,
          remessa,
          codacordo,
        );
        let resp = await api.post("unismg/dadosparcelacriterio", {
          cpf,
          cgc,
          contrato,
          remessa,
          codacordo,
        });
        //console.log("resp", resp.data);
        let faturas = resp.data.dados.faturas;
        this.$store.dispatch("insereUnismgFaturas", faturas);
        let criterios = resp.data.dados.criterios[0];
        this.$store.dispatch("insereUnismgCriterios", criterios);
        // console.log('crit',this.$store.state.unismg_criterios)
        let var_mora = parseFloat(criterios.perc_mora);
        let multa = parseFloat(criterios.perc_multa);
        let desc_avista = parseFloat(criterios.perc_desconto_avista);
        let desc_encargos = parseFloat(criterios.perc_desc_encargos);
        //let desc_parc = parseFloat(criterios.perc_desconto_parc)
        //let perc_entrada = parseFloat(criterios.perc_entrada)
        let parc_min = parseFloat(criterios.parcela_minima);

        let qtdeFaturas = faturas.length;
        let totalFaturas = 0,
          moraTotal = 0,
          multaTotal = 0;
        let dataVenc;

        faturas.forEach((e) => {
          totalFaturas = totalFaturas + parseFloat(e.pdvalor);
          let difdatas = calcDividaUnismg(e.pddtvencto.substring(0, 10));
          dataVenc = difdatas.d2;

          let valor1 = parseFloat(e.pdvalor) * difdatas.dias;
          let mora_por_fatura = (var_mora / 30 / 100) * valor1;
          let multa_por_fatura = (parseFloat(e.pdvalor) * multa) / 100;

          multaTotal = multaTotal + multa_por_fatura;
          moraTotal = moraTotal + mora_por_fatura;
        });
        //console.log('result',totalFaturas,qtdeFaturas,moraTotal,multaTotal)
        //console.log('result2',typeof totalFaturas,typeof qtdeFaturas,typeof moraTotal,typeof multaTotal)
        let divida_atualizada = totalFaturas + moraTotal + multaTotal;
        //console.log('div',divida_atualizada)
        divida_atualizada = Math.ceil(divida_atualizada * 100) / 100;
        //console.log('div',typeof divida_atualizada,divida_atualizada,this.item.cpsaldev)
        //let divida_str = divida_atualizada.toString().split('.')
        //let divida_str2 = divida_str[0] +'.'+ divida_str[1].substring(0,2)
        let divida_ori = this.item.cpsaldev;
        this.item.cpsaldev = divida_atualizada; //parseFloat(divida_str2)

        /* testando parc 1
        let pri = totalFaturas * (desc_avista / 100);
        let pri2 = moraTotal + multaTotal;
        let pri3 = (moraTotal + multaTotal) * (desc_encargos / 100);

        let _1x = totalFaturas - pri + (pri2 - pri3);

        _1x = Math.ceil(_1x * 100) / 100;
*/
        let pri = 0;
        let _1x = 0;
        let pri2 = moraTotal + multaTotal;
        let pri3 = (moraTotal + multaTotal) * (desc_encargos / 100);
        for (let i = 0; i <= desc_avista; i++) {
          pri = totalFaturas * ((desc_avista - i) / 100);
          _1x = totalFaturas - pri + (pri2 - pri3);
          if (_1x > parc_min) {
            break;
          }
        }
        _1x = Math.ceil(_1x * 100) / 100;

        let _2xdemais = (totalFaturas - pri + (pri2 - pri3)) / 2;

        let _3xdemais = (totalFaturas - pri + (pri2 - pri3)) / 3;

        //Se qtdeFaturas > 1
        // let _4xdemais = (totalFaturas + pri2) /4
        if (qtdeFaturas == 1) _3xdemais; // _4xdemais = 0

        let obj = {
          cpf,
          contrato,
          cgc,
          remessa,
          divida_atualizada,
          divida_ori,
          _1x,
          _2xdemais,
          _3xdemais,
          dataVenc,
          qtdeFaturas,
          parc_min,
          codacordo,
          faturas,
        };
        this.$store.dispatch("insereUnismgValores", obj);
        console.log("obj", obj);
        //---------------------------------------------------------
        //this.item.cpsaldev = 23.6
        this.overlay = false;
      } catch (e) {
        console.log("err divida", e.message);
        this.$router.push({ name: "ErroPage" });
      }
    }
  },

  methods: {
    async pegaDivida(contratoAtual, credorAtual) {
      let logNegoc = {
        credor: this.item.credor2,
        cgc: this.item.cpcgc,
        cpf: this.item.cpcpfcgc,
        contrato: this.item.contrato,
        log_status: `cpf ${this.item.cpcpfcgc} saiu na página de dívidas`,
        negoc: "",
        parcelas_qtde: "",
        entrada: "",
        parcela: "",
      };
      await atualizarLogNegoc(logNegoc);
      // console.log("contratoAtual", contratoAtual, credorAtual);
      // if (credorAtual.trim() == "DIVZERO RECUPERAÇÃO DE CRÉDITOS LTDA") {
      //   // colocar aqui a página de telefonar p easycob
      //   return this.$router.push({ name: "ContatoPage" });
      // }

      this.loading = true;
      let divida = this.$store.state.dividas.filter(function(divida) {
        return divida.contrato == contratoAtual && divida.credor == credorAtual;
      });
      this.$store.dispatch("marcaDividaAtual", divida[0]);

      let credor = this.$store.state.divida_atual.credor;

      if (
        divida[0].cpcgc == "04206050000180" ||
        divida[0].cpcgc == "04206050000181"
      ) {
        let temOferta = await api.get(
          "tim/ofertasite/" +
            divida[0].cpcpfcgc.trim() +
            "/" +
            divida[0].contrato.trim(),
        );
        console.log("tem oferta tim", temOferta.data.dados.cli);
        if (!temOferta.data.dados.cli) {
          logNegoc.log_status = `cpf ${logNegoc.cpf} entrou no Tim Negocia`;
          await atualizarLogNegoc(logNegoc);
          return (window.location = "https://www.timnegocia.com.br");
        } else {
          logNegoc.log_status = `cpf ${logNegoc.cpf} entrou no Tim Ofertas`;
          await atualizarLogNegoc(logNegoc);
          console.log(
            "tem oferta tim",
            divida[0].cpcpfcgc.trim(),
            divida[0].contrato.trim(),
            divida[0].cpcgc.trim(),
          );
          return this.$router.push({
            path: `ofertatim/${divida[0].cpcgc.trim()}/${divida[0].cpcpfcgc.trim()}/${divida[0].contrato.trim()}`,
          });
        }
      }

      try {
        await this.$store.dispatch("marcaCredorAtual", credor);

        let repac = false;
        if (
          divida[0].credor2 == "OI MOVEL" ||
          divida[0].credor2 == "OI TV DTH" ||
          divida[0].credor2 == "OI CAMPANH" ||
          divida[0].credor2 == "TELEMARCAM" ||
          divida[0].credor2 == "TV DTH CAM" ||
          divida[0].credor2 == "CABO CAMP" ||
          divida[0].credor2 == "OI FIXO" ||
          divida[0].credor2 == "NIO"
        ) {
          repac = true;
        }

        let dados = {
          cgc: divida[0].cpcgc,
          cpf: divida[0].cpcpfcgc,
          contrato: divida[0].contrato,
          remessa: divida[0].cpdatrem,
          repac,
        };

        let resposta = await api.post("logs/conferenegoc", dados);
        console.log(dados);
        console.log(resposta.data.dados.length);
        if (resposta.data.dados.length != 0 && dados.cgc != "71208516000174") {
          throw new Error("Oooops!");
        }

        if (divida[0].cpcgc == "50510071000102") {
          console.log("entrou no if cgc divzero", divida[0].contrato);
          let respA = this.$store.state.dividas_divzero;
          //console.log("respA", respA);
          let dividaAgora = respA.filter(function(item) {
            return item.DebtNumber == divida[0].contrato;
          });
          console.log("dividaagora", dividaAgora);
          await this.$store.dispatch(
            "insereDividasDivZeroAtual",
            dividaAgora[0],
          );
        }

        this.loading = false;
        this.$router.push({ name: "PlanosPage" });
      } catch (e) {
        this.$router.push({ name: "ErroPage" });
      }
    },
  },
};
</script>

<style></style>
